
export default function Solution() {
  return (
    <section className="py-20 md:py-32 px-4 bg-white relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-10 right-10 w-32 h-32 bg-teal-100 rounded-full opacity-50"></div>
      <div className="absolute bottom-10 left-10 w-24 h-24 bg-yellow-100 rounded-full opacity-50"></div>
      
      <div className="container mx-auto max-w-7xl">
        {/* Main image */}
        <div className="text-center mb-16">
          <img 
            src="https://static.readdy.ai/image/da7665bf3996c3ea364553a32910e66f/720527b4ccfbe6c13e23d8ede09714be.png" 
            alt="CalculaDP Sistema" 
            className="w-full max-w-5xl mx-auto rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-300"
          />
        </div>

        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-6">
            Chega de planilhas<br />
            <span className="text-teal-600">desorganizadas!</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-600 max-w-4xl mx-auto">
            Tenha todos os cálculos e relatórios salvos automaticamente 
            em nuvem em um sistema seguro.
          </p>
        </div>

        {/* Benefits grid */}
        <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-3xl p-8 md:p-12 border border-teal-100">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div className="group">
              <div className="bg-teal-600 p-6 rounded-2xl inline-flex mb-4 group-hover:bg-teal-700 transition-colors">
                <i className="ri-history-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900">Histórico Completo</h3>
              <p className="text-gray-600">Todos os cálculos ficam salvos em nuvem para consulta futura e auditoria</p>
            </div>

            <div className="group">
              <div className="bg-teal-600 p-6 rounded-2xl inline-flex mb-4 group-hover:bg-teal-700 transition-colors">
                <i className="ri-file-pdf-2-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900">PDFs Com Logo</h3>
              <p className="text-gray-600">Relatórios personalizados com sua logo em segundos</p>
            </div>

            <div className="group">
              <div className="bg-teal-600 p-6 rounded-2xl inline-flex mb-4 group-hover:bg-teal-700 transition-colors">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900">100% Seguro</h3>
              <p className="text-gray-600">Seus dados protegidos com criptografia avançada</p>
            </div>
          </div>

          {/* Additional features */}
          <div className="mt-12 grid md:grid-cols-2 gap-6">
            <div className="flex items-start gap-4 bg-white rounded-xl p-6 shadow-sm">
              <div className="bg-green-100 p-3 rounded-lg flex-shrink-0">
                <i className="ri-check-line text-xl text-green-600"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2">Cálculos Automáticos</h4>
                <p className="text-gray-600 text-sm">O sistema calcula automaticamente pontos e rescisões e encargos</p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white rounded-xl p-6 shadow-sm">
              <div className="bg-green-100 p-3 rounded-lg flex-shrink-0">
                <i className="ri-refresh-line text-xl text-green-600"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2">Sempre Atualizado</h4>
                <p className="text-gray-600 text-sm">Atualizações automáticas conforme mudanças na legislação</p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white rounded-xl p-6 shadow-sm">
              <div className="bg-green-100 p-3 rounded-lg flex-shrink-0">
                <i className="ri-smartphone-line text-xl text-green-600"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2">Acesse de Qualquer Lugar</h4>
                <p className="text-gray-600 text-sm">Funciona no computador, tablet e celular</p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white rounded-xl p-6 shadow-sm">
              <div className="bg-green-100 p-3 rounded-lg flex-shrink-0">
                <i className="ri-customer-service-2-line text-xl text-green-600"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-2">Suporte Especializado</h4>
                <p className="text-gray-600 text-sm">Nossa equipe, com experiência em DP, estará no suporte via WhatsApp para te ajudar.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
